import { Component } from '@angular/core';

import { QuoteInfoService } from '../../services/quote-info.service';
import { CurrentUserService } from '../../services/current-user.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ApprovedLockService } from '../../services/approved-lock.service';
import { BrowserWidthService } from '../../services/browser-width.service';

@Component({
  selector: 'edit-quote-button',
  template: `
    <button
      class="yeti-button-attention yeti-grid-phone-12"
      *ngIf="
        (quoteInfoService.quote$ | async).ApprovalStatusDescription !==
          'Not Submitted' &&
        (quoteInfoService.quote$ | async).quoteId !== null &&
        (currentUserService.currentUser$ | async).roles.includes(
          'MyCustomHomes'
        ) &&
        (url.includes('customer-info') ||
          url.includes('choose-product-line') ||
          url.includes('choose-model') ||
          url.includes('options-configuration') ||
          url.includes('order-information') ||
          url.includes('quote-summary'))
      "
      (click)="approvedLockService.showModal()"
      [ngStyle]="browserWidthService.mobileButtonStyle"
    >
      Edit Quote
    </button>
  `,
  styles: [require('./edit-quote-button.component.scss')]
})
export class EditQuoteButtonComponent {
  constructor(
    public quoteInfoService: QuoteInfoService,
    public currentUserService: CurrentUserService,
    public loadingSpinnerService: LoadingSpinnerService,
    public approvedLockService: ApprovedLockService,
    public browserWidthService: BrowserWidthService
  ) {}

  get url(): string {
    return window.location.href;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/edit-quote-button/edit-quote-button.component.ts